/*
    Module definition for browserify
*/
require('./dist/filepicker');
module.exports = filepicker;



/*****************
 ** WEBPACK FOOTER
 ** ./~/filepicker-js/index.js
 ** module id = 178
 ** module chunks = 0
 **/